<template>
  <div class="law_statistic-list">
    <div
      v-for="item in list"
      :key="item.id"
    >
      <div
        class="law_statistic-list-item"
      >
          <div 
            class="trans_name"
            @click="sendDetails(item.id)"
          >
            {{ item.transName }}
          </div>
          <div class="upload">
            <img src="@/assets/icons/excel.png" alt="" aria-hidden="true" />
            <a :href="baseUrl + item.uploadFile" :aria-label="$t('Скачать') + ': ' + item.transName">{{ $t('Скачать') }}</a>
          </div>
      </div>
     </div> 
  </div>
</template>
<script>

import LAW from '@/model/law'

export default {
  name: 'LawStatisticList',
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  computed: {
    baseUrl () {
      let baseUrl = process.env.VUE_APP_BACK_URL
      return baseUrl.substring(0, baseUrl.length - 1)
    },
  },
  methods: {
    sendDetails (type) {
        this.$router.push({
          name: 'law-statistic-details',
          params: {
            type: type
          }
        })
    }
  }
}
</script>
<style lang="scss" scoped>
  .law_statistic-list {
    border: 1px solid silver;
    border-bottom: none;
    

    display: inline-block;
    
    &-item {
      display: flex;
      align-items: center;
      border-bottom: 1px solid silver;
      min-height: 40px;
      padding: 5px 5px;

      .trans_name {
        width: 500px;
        padding-left: 10px;
        text-decoration: underline;
        cursor: pointer;
        font-weight: 400;
      }

      .upload {
        border-left: 1px solid silver;
        padding: 0px 10px;
        height: 40px;
        display: flex;
        align-items: center;

        a {
          color: #333;
          text-decoration: underline;
        }

        img {
          width: 24px;
          margin-right: 10px;
        }
      }
    }
  }
</style>
